import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import FeedbackForm from "./components/FeedbackForm";

const contactItems = [
  { icon: "ri-mail-line", label: "联系邮箱", value: "contact@91baoliao.example.com", note: "新闻线索与合作洽谈" },
  { icon: "ri-phone-line", label: "热线电话", value: "400-091-8896", note: "工作日 9:00 - 18:00" },
  { icon: "ri-map-pin-line", label: "办公地址", value: "北京市朝阳区新闻大厦 A 座 18 层", note: "来访请提前预约" },
];

export default function ContactPage() {
  useDocumentMeta({
    title: "联系我们_91爆料_新闻线索与合作洽谈",
    description:
      "联系91爆料：提供新闻线索、反馈问题或洽谈合作，可通过邮箱、热线电话或在线反馈表单与我们取得联系。",
    keywords: "91爆料,联系我们,新闻线索,合作洽谈,意见反馈",
  });

  return (
    <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6">
      {/* 头部 */}
      <section>
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-medium text-accent-700">
          <i className="ri-customer-service-2-line"></i>
          联系我们
        </span>
        <h1 className="mt-4 font-heading text-3xl font-black text-foreground-900 md:text-4xl">你的声音，我们都在听</h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-500 md:text-base">
          无论是新闻线索、内容反馈，还是商务合作，欢迎随时联系我们。我们会认真对待每一条留言。
        </p>
      </section>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
        {/* 联系方式 */}
        <div className="space-y-4 lg:col-span-2">
          {contactItems.map((item) => (
            <div key={item.label} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div>
                <p className="text-xs font-medium text-foreground-400">{item.label}</p>
                <p className="mt-1 text-sm font-semibold text-foreground-900">{item.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{item.note}</p>
              </div>
            </div>
          ))}
          <div className="rounded-lg border border-background-200 bg-secondary-100 p-5">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
              <i className="ri-lightbulb-line text-accent-600"></i>
              提供爆料线索
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-secondary-800">
              如果你掌握第一手线索，欢迎通过表单与我们联系。我们承诺认真核实、妥善处理每一条有效信息。
            </p>
          </div>
        </div>

        {/* 反馈表单 */}
        <div className="lg:col-span-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <div className="mb-5 flex items-center gap-2">
              <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
              <h2 className="font-heading text-xl font-bold text-foreground-900">在线反馈</h2>
            </div>
            <FeedbackForm />
          </div>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap gap-3 border-t border-background-200 pt-8">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/about"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          了解我们
        </Link>
      </div>
    </div>
  );
}